import ClusterTypesAPI from 'dashboard/api/clusterTypes';

export const state = {
  records: [],
  uiFlags: { isFetching: false },
};

export const getters = {
  getTypes: $state => $state.records,
  getTypeById: $state => id => $state.records.find(r => r.id === Number(id)),
};

export const actions = {
  async fetch({ commit }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await ClusterTypesAPI.get();
      commit('setTypes', data);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async create({ commit }, payload) {
    const { data } = await ClusterTypesAPI.create(payload);
    commit('upsertType', data);
    return data;
  },

  async update({ commit }, { id, ...payload }) {
    const { data } = await ClusterTypesAPI.update(id, payload);
    commit('upsertType', data);
    return data;
  },

  async delete({ commit }, id) {
    await ClusterTypesAPI.delete(id);
    commit('removeType', id);
  },
};

export const mutations = {
  setUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  setTypes($state, records) {
    $state.records = records || [];
  },
  upsertType($state, record) {
    if (!record || !record.id) return;
    const i = $state.records.findIndex(r => r.id === record.id);
    if (i > -1) {
      const next = [...$state.records];
      next[i] = record;
      $state.records = next;
    } else {
      $state.records = [record, ...$state.records];
    }
  },
  removeType($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default { namespaced: true, state, getters, actions, mutations };
